import { render, staticRenderFns } from "./TokenPassword.vue?vue&type=template&id=7678ab23&scoped=true&"
import script from "./TokenPassword.vue?vue&type=script&lang=js&"
export * from "./TokenPassword.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7678ab23",
  null
  
)

/* custom blocks */
import block0 from "./TokenPassword.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports